import React, { useState,useEffect,useRef } from 'react'
import withCMSLayout from '../sections/withCMSLayout'
import { useAlert } from '../../../../context/AlertContext'



import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Link } from 'react-router-dom';
import kioskInfoServices from '../kioskInfoServices';
import KioskInfoForm from '../components/KioskInfoForm';
import { Switch } from '@mui/material';

import useSystemMasterList from '../../../../hooks/useSystemMasterList'
import withModuleSetting from '../../../../section/withModuleSetting';


const CellLink = (params) =>{
  return (
      <Link to={`/cms/kiosk-info/details/${params.data.id}`}>{params.data.title}</Link>
  )
}

const CellSwitch = (params) =>{
  return (
    <Switch 
      color="success"
      checked={params.data.status === 1}
      onChange={(e)=>params.handleStatusChange(e,params.data.id)}
    />
  )
}

function ManageKioskInfoPage() {

  const {AppAlert} = useAlert();
  const gridRef = useRef();
  const [userList,setUserList] = useState(null);

  const [masters,getMasterLabel] = useSystemMasterList(['kiosk-info-category']);

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
  const prepairColumnDef = () => {
    if(masters){
      let _columnDefs = [
          {field:"id",headerName: "ID"},
          {headerName:"Title", width:"200", valueGetter: params => params.data.title,cellRenderer: CellLink},
          {headerName:"Category", width:"200", valueGetter: params => getMasterLabel("kiosk-info-category",params.data.categoryId)},
          {headerName:"Status", width:"200", cellRenderer: CellSwitch, cellRendererParams: {
            handleStatusChange:handleStatusChange
          }},
          
      ];
      setColumnDef(_columnDefs);
    }
      
  }

  const getKioskInfoList = () =>{
    kioskInfoServices.getList().then(res=>{
        setUserList(res.data);
    }).catch(error=>{
        AppAlert(error.msg,"error")
    })
  }

  useEffect(()=>{
    prepairColumnDef();
  },[masters])


  const handleStatusChange = (e,id) =>{
    let payload = {
      id:id,
      status:e.target.checked ? 1 : 0,
    }
    console.log(payload);
    kioskInfoServices.save(payload).then(res=>{
      getKioskInfoList();
    })
  }
  
  return (
    <div className='row'>
        <div className='col-md-9'>
          <h3>Kiosk Info</h3>
        </div>
        <div className='col-md-3'>
          <span className='float-end'><KioskInfoForm refreshList={getKioskInfoList} masters={masters} /></span>
        </div>
        <div className='col-md-12 mt-3'>
            <div className="ag-theme-alpine" style={{height: 400}}>
                <AgGridReact
                  ref={gridRef}
                  rowData={userList}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  animateRows={true}
                  onGridReady={getKioskInfoList}
                >
                </AgGridReact>
            </div>
        </div>
    </div>
  )
}

export default withCMSLayout(withModuleSetting(ManageKioskInfoPage,"kioskInfoModule"))












/*

import { Drawer } from '@mui/material'

const [drawerStatus,setDrawerStatus] = useState(false)
<Drawer
        open={drawerStatus}
        onClose={()=>setDrawerStatus(false)}
        anchor='right'
        PaperProps={{sx:{width:"40%"}}}
        
      >
          <div className='row'>
            <div className='col-md-12'>
              hhshsh
            </div>
          </div>
      </Drawer>
      <button className='btn btn-primary' onClick={()=>setDrawerStatus(true)} >OPen </button>


*/